(function () {
  function initShangqing(section) {
    if (!section || section.dataset.sqInitialized === "true") return;
    section.dataset.sqInitialized = "true";

    var buttons = section.querySelectorAll("[data-lang-btn]");

    function setLanguage(lang) {
      section.dataset.lang = lang;
      buttons.forEach(function (button) {
        button.setAttribute("aria-pressed", String(button.dataset.langBtn === lang));
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        setLanguage(button.dataset.langBtn);
      });
    });

    var observer = "IntersectionObserver" in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("in");
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" })
      : null;

    section.querySelectorAll(".sq-reveal").forEach(function (element) {
      if (observer) observer.observe(element);
      else element.classList.add("in");
    });

    var form = section.querySelector("[data-sq-inquiry-form]");
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var data = new FormData(form);
        var to = form.dataset.mailTo || "shangqingpaper@gmail.com";
        var lines = [
          "Name: " + (data.get("name") || ""),
          "Company: " + (data.get("company") || ""),
          "Email: " + (data.get("email") || ""),
          "Country / Phone: " + (data.get("phone") || ""),
          "Product: " + (data.get("product") || ""),
          "",
          data.get("message") || ""
        ];
        window.location.href = "mailto:" + encodeURIComponent(to) +
          "?subject=" + encodeURIComponent("Shangqing Paper Inquiry") +
          "&body=" + encodeURIComponent(lines.join("\n"));
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-shangqing-section]").forEach(initShangqing);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    initShangqing(event.target.querySelector("[data-shangqing-section]"));
  });
})();
